import {
  getLeadingImportDateHeading,
  getRepeatedInlineImportDateMatches,
  isLongNoteEmailText,
} from './parsing';
import {
  getQuickLogRoutingDecision,
  isQuickLogLongNoteText,
} from '../../utils/quickLogRoutingDecision';
import { CARE_SOURCE_TYPES } from './sourceTypes';

const hasFileAttachment = (value) => Boolean(value);

const REVIEW_ROUTING_MODES = new Set([
  'small_structured_review',
  'long_note_review',
]);

const MIN_SOURCE_ROW_TEXT_LENGTH = 12;

const getSourceCandidateRows = (text = '') => (
  String(text || '')
    .replace(/\r\n/g, '\n')
    .replace(/\r/g, '\n')
    .split(/\n+/)
    .map((line) => line.trim())
    .filter((line) => line.length >= MIN_SOURCE_ROW_TEXT_LENGTH)
);

const getDatedSourceRowCount = (text = '') => {
  const rows = getSourceCandidateRows(text);
  const leadingDateCount = rows.filter((row) => (
    getLeadingImportDateHeading(row, {
      fallbackDate: new Date(),
      sourceText: row,
    })
  )).length;
  const inlineDateCount = getRepeatedInlineImportDateMatches(text).length;

  return Math.max(leadingDateCount, inlineDateCount);
};

export const hasClearDatedSourceStructure = (text = '') => (
  getDatedSourceRowCount(text) >= 2
);

const shouldRouteDecisionToAsyncSource = (routingDecision = {}) => {
  const mode = String(routingDecision?.mode || routingDecision?.finalMode || '').trim();
  const baseMode = String(routingDecision?.baseMode || '').trim();

  return REVIEW_ROUTING_MODES.has(mode)
    || REVIEW_ROUTING_MODES.has(baseMode)
    || Boolean(routingDecision?.shouldReviewInApp);
};

export const shouldCaptureTextAsAsyncCareSource = ({
  text = '',
  photoFile = null,
  routingDecision = null,
} = {}) => {
  const rawText = String(text || '').trim();
  if (!rawText || hasFileAttachment(photoFile)) {
    return false;
  }

  const decision = routingDecision || getQuickLogRoutingDecision(rawText);

  return shouldRouteDecisionToAsyncSource(decision)
    || hasClearDatedSourceStructure(rawText)
    || isQuickLogLongNoteText(rawText)
    || isLongNoteEmailText(rawText);
};

export const resolveAsyncCareSourceTypeForText = (text = '') => (
  isLongNoteEmailText(text)
    ? CARE_SOURCE_TYPES.INCOMING_MESSAGE
    : CARE_SOURCE_TYPES.TYPED_LONG_NOTE
);
